import(/* webpackMode: "eager" */ "/app/apps/explore/app/(explore)/@printControl/[locale]/explore/page.tsx");
